import { Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { T } from 'react-polyglot-hooks';

// const image = require('./undraw_page_not_found.svg');

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(4)
    },
    content: {
        paddingTop: 150,
        textAlign: 'center'
    },
    image: {
        marginTop: 50,
        display: 'inline-block',
        maxWidth: '100%',
        width: 560
    },
}));

const Maintenance = () => {
    const classes = useStyles();
    let message = '';

    // tslint:disable-next-line:no-unused-expression
    // @ts-ignore
    const messageElement = document.head.querySelector<HTMLMetaElement>('[name~="maintenance-message"]');

    if (messageElement) {
        message = messageElement.content;
    }

    return (
        <div className={classes.root}>
            <Grid container justify="center" spacing={4}>
                <Grid item lg={8} xs={12}>
                    <div className={classes.content}>
                        <Typography variant="h1" style={{fontSize: 48, marginBottom: '2rem'}}>
                            <T phrase="We will be back shortly, please check back later"/>
                        </Typography>

                        {message !== '' && (
                            <Typography variant="subtitle1" style={{fontSize: 24}}>
                                <T phrase={message}/>
                            </Typography>
                        )}
                        {/*<img alt="page not found" className={classes.image} src={image}/>*/}
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default Maintenance;
